import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import logoMark from "../../assets/home-page/header/logo-mark-glasses.svg";
import logoTextGenz from "../../assets/home-page/header/logo-text-genz.svg";
import logoTextPaisa from "../../assets/home-page/header/logo-text-paisa.svg";
import { siteConfig } from "../../config/site";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us" },
  { label: "Services", href: "/services" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "Contact Us", href: "/contact-us" },
];

export function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full bg-white">
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between p-6">
        {/* Logo */}
        <Link
          to="/"
          onClick={() => setIsMenuOpen(false)}
          className="relative h-[65.518px] w-[129.3px] shrink-0"
        >
          <img
            src={logoMark}
            alt=""
            className="absolute left-[4.23px] top-[10.08px] h-[45.35px] w-[52.16px]"
          />
          <img
            src={logoTextGenz}
            alt=""
            className="absolute left-[61.8px] top-[9.65px] h-[20.08px] w-[63.27px]"
          />
          <img
            src={logoTextPaisa}
            alt="GenzPaisa"
            className="absolute left-[65.18px] top-[31.08px] h-[24.8px] w-[58.35px]"
          />
        </Link>

        {/* Nav links — desktop only */}
        <nav className="hidden items-center gap-10 lg:flex">
          {NAV_LINKS.map((link) => {
            const active = location.pathname === link.href;
            return (
              <Link
                key={link.label}
                to={link.href}
                className={`relative font-[Plus_Jakarta_Sans] text-[15px] leading-[22.5px] ${
                  active ? "py-1 font-semibold text-[#2d0c5a]" : "font-medium text-[#4b5563] hover:text-[#2d0c5a]"
                }`}
              >
                {link.label}
                {active ? (
                  <span className="absolute bottom-[0.5px] left-0 right-0 h-[2.5px] rounded-full bg-[#2d0c5a]" />
                ) : null}
              </Link>
            );
          })}
        </nav>

        {/* CTA buttons — desktop only */}
        <div className="hidden items-center lg:flex">
          <a
            href={siteConfig.loginLink || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full px-[25px] py-[11px] text-sm font-semibold leading-5 text-[#2d0c5a] transition-colors hover:bg-[#2d0c5a]/5"
          >
            Login
          </a>
          <a
            href={siteConfig.repayNowLink || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full border border-solid border-[#2d0c5a] px-[25px] py-[11px] text-sm font-semibold leading-5 text-[#2d0c5a] transition-colors hover:bg-[#2d0c5a]/5"
          >
            Repay Now
          </a>
          <a
            href={siteConfig.applyLink || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 rounded-full bg-[#046360] px-7 py-[10px] text-sm font-semibold leading-5 text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-colors hover:bg-[#03514f]"
          >
            Apply Now
          </a>
        </div>

        {/* Hamburger toggle — tablet/mobile only */}
        <button
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
          className="flex h-10 w-10 items-center justify-center rounded-full text-[#2d0c5a] transition-colors hover:bg-[#2d0c5a]/5 lg:hidden"
        >
          {isMenuOpen ? <FiX className="h-6 w-6" /> : <FiMenu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile/tablet menu panel */}
      {isMenuOpen ? (
        <div className="border-t border-solid border-[#e2e8f0] px-6 py-6 lg:hidden">
          <nav className="flex flex-col gap-5">
            {NAV_LINKS.map((link) => {
              const active = location.pathname === link.href;
              return (
                <Link
                  key={link.label}
                  to={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-base ${
                    active ? "font-semibold text-[#2d0c5a]" : "font-medium text-[#4b5563]"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="mt-6 flex flex-col gap-3">
            <a
              href={siteConfig.loginLink || undefined}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
              className="rounded-full px-[25px] py-[11px] text-center text-sm font-semibold leading-5 text-[#2d0c5a] transition-colors hover:bg-[#2d0c5a]/5"
            >
              Login
            </a>
            <a
              href={siteConfig.repayNowLink || undefined}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
              className="rounded-full border border-solid border-[#2d0c5a] px-[25px] py-[11px] text-center text-sm font-semibold leading-5 text-[#2d0c5a] transition-colors hover:bg-[#2d0c5a]/5"
            >
              Repay Now
            </a>
            <a
              href={siteConfig.applyLink || undefined}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
              className="rounded-full bg-[#046360] px-7 py-[10px] text-center text-sm font-semibold leading-5 text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-colors hover:bg-[#03514f]"
            >
              Apply Now
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}
